import { TextField } from '@mui/material';
import { addCategoryThunk, getCategoriesThunk } from '@redux/features/category.slice';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import Modal from 'Common/Components/Modal';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import { useFormik } from 'formik';
import React, { FC } from 'react';
import * as Yup from 'yup';

interface IProps {
    show: boolean;
    handleClose: () => void;
}

const AddCategoryModal: FC<IProps> = ({ show, handleClose }) => {
    const { createLoading } = useAppSelector((state: RootState) => (state as any).categoryState || { createLoading: false });
    const dispatch = useAppDispatch();

    const validationSchema = Yup.object({
        categoryName: Yup.string().required('Category Name is required'),
    });

    const handleSubmit = (values: any) => {
        dispatch(addCategoryThunk({ categoryName: values.categoryName } as any)).then((res: any) => {
            if (res.meta.requestStatus === 'fulfilled') {
                handleClose();
                formik.resetForm();
                dispatch(getCategoriesThunk());
            }
        });
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: { categoryName: '' },
        validationSchema,
        onSubmit: handleSubmit,
    });

    return (
        <Modal
            show={show}
            onHide={() => handleClose()}
            dialogClassName="w-full bg-white p-3 shadow rounded-md overflow-scroll md:w-[500px] md:max-h-[80vh]"
        >
            <Modal.Header>
                <Modal.Title className="text-lg font-semibold">Add Category</Modal.Title>
            </Modal.Header>
            <Modal.Body className="my-5">
                <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
                    <TextField
                        size="small"
                        fullWidth
                        id="categoryName"
                        name="categoryName"
                        label="Category Name"
                        value={formik.values.categoryName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.categoryName && Boolean(formik.errors.categoryName)}
                        helperText={formik.touched.categoryName && formik.errors.categoryName}
                    />
                </form>
            </Modal.Body>
            <Modal.Footer className="flex items-center justify-center gap-2 mt-5">
                <ButtonBase
                    innerText="Cancel"
                    className="bg-gray-500 hover:bg-gray-600 rounded border-none px-4 py-2 text-white"
                    onClick={() => {
                        handleClose();
                        formik.resetForm();
                    }}
                    disabled={createLoading}
                />
                <ButtonBase
                    innerText="Add Category"
                    className="bg-yellow-600 hover:bg-yellow-800 rounded border-none px-4 py-2 text-white disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={formik.handleSubmit}
                    disabled={createLoading || !formik.values.categoryName}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default AddCategoryModal;
